export enum TemplateCreationType {
  Existing = 'Existing',
  New = 'New'
}
